import { useSelector } from "react-redux";
import { RootState } from "State/store";

export const useSelectedAddress = () =>
  useSelector((state: RootState) => state.customer.selectedAddress);
